<template>
  <div class="language-picker">
    <div
      class="language"
      :class="language.key === currentLanguage ? ['isDisabled', 'isActive'] : 'isClickable'"
      v-for="language in languages"
      :key="language.key"
      @click="changeLanguage(language)"
    >
      {{ language.key }}
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "LanguagePicker",
  computed: {
    ...mapState({
      languages: state => state.languages,
      currentLanguage: state => state.currentLanguage
    })
  },
  methods: {
    changeLanguage(language){
      return this.$bubbleUp('selectLanguage', language)
    }
  }
}
</script>

<style lang="scss">
@import "LanguagePicker.scss";
</style>
